// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuButton_root__3qXOT"};